// extracted by mini-css-extract-plugin
export default {"tabs_list":"index_tabs_list_YtFX7 clearfix","tabsItem":"index_tabsItem_cmQ9u"};